<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-show="!connect.editable"
          icon
          v-bind="attrs"
          v-on="on"
          @click.stop="BeforeSwap"
        >
          <v-avatar size="22" rounded>
            <img
              src="data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAwIDEwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZmlsbD0iIzAwMDAwMCIgZD0iTTMxLjYsNy45aC0xOWMtMS4yLDAtMi4yLDEtMi4yLDIuMnYxOC41YzAsMS4yLDEsMi4yLDIuMiwyLjJoMTljMS4yLDAsMi4yLTEsMi4yLTIuMlYxMC4xICAgQzMzLjgsOC45LDMyLjgsNy45LDMxLjYsNy45eiI+PC9wYXRoPjxwYXRoIGZpbGw9IiMwMDAwMDAiIGQ9Ik0zMS42LDM3LjNoLTE5Yy0xLjIsMC0yLjIsMS0yLjIsMi4ydjE4LjVjMCwxLjIsMSwyLjIsMi4yLDIuMmgxOWMxLjIsMCwyLjItMSwyLjItMi4yVjM5LjQgICBDMzMuOCwzOC4yLDMyLjgsMzcuMywzMS42LDM3LjN6IE0yNy4yLDUzLjZIMTYuOXYtOS44aDEwLjNWNTMuNnoiPjwvcGF0aD48cGF0aCBmaWxsPSIjMDAwMDAwIiBkPSJNMzEuNiw2Ny43aC0xOWMtMS4yLDAtMi4yLDEtMi4yLDIuMnYxOC41YzAsMS4yLDEsMi4yLDIuMiwyLjJoMTljMS4yLDAsMi4yLTEsMi4yLTIuMlY2OS44ICAgQzMzLjgsNjguNywzMi44LDY3LjcsMzEuNiw2Ny43eiBNMjcuMiw4NEgxNi45di05LjhoMTAuM1Y4NHoiPjwvcGF0aD48cGF0aCBmaWxsPSIjMDAwMDAwIiBkPSJNNzUuNSwxOS41bDEuOS00YzEuMy0yLjgtMC44LTYtMy45LTUuN2wtMjYuOCwyLjFjLTIuOSwwLjItNC41LDMuNS0yLjksNmwxNC42LDIxLjNjMiwyLjksNi40LDIuNiw3LjktMC42ICAgbDEuOS0zLjljMC41LTEsMS44LTEuMywyLjYtMC42YzYuMiw1LjIsMTAuMSwxMi45LDEwLjEsMjEuNmMwLDExLjgtNy4zLDIxLjktMTcuNSwyNi4xYy0yLjEsMC45LTMuNiwyLjgtMy43LDUgICBjLTAuMiw0LjEsMy45LDcuMSw3LjcsNS41YzE0LjUtNS44LDI0LjgtMjAuMSwyNC44LTM2LjdjMC0xMi44LTYuMS0yNC4xLTE1LjUtMzEuNEM3NS4yLDIzLjEsNzQuNywyMS4yLDc1LjUsMTkuNXoiPjwvcGF0aD48L2c+PC9zdmc+"
              :style="{
                filter: false
                  ? 'invert(0.7) sepia(0) saturate(5) hue-rotate(175deg)'
                  : 'invert(0.5) sepia(1) saturate(5) hue-rotate(175deg)',
              }"
            />
          </v-avatar>
        </v-btn>
      </template>
      <span>ย้าย</span>
    </v-tooltip>
    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-card max-height="300" width="400">
        <v-list>
          <v-list-item
            v-for="(item, i) in JumpQuestion.connect"
            @click="moveto(connect, item)"
            :key="item.questionID"
            :disabled="item.questionID === connect.questionID"
          >
            <v-list-item-title
              >{{ i + 1 }}. {{ item.questionLabel }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["questionlist", "JumpQuestion", "connect", "surveyStatus"],
  data() {
    return {
      showMenu: false,
      x: 0,
      y: 0,
    };
  },
  computed: {
    Editing() {
      return this.$store.state.editing;
    },
  },
  methods: {
    BeforeSwap(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        if (this.Editing) {
          Swal.fire({
            title: "",
            text: `คุณมีการแก้ไข "${this.$store.state.editingPreData.questionLabel}" ค้างไว้ กรุณาดำเนินการให้เรียบร้อย`,
            icon: "warning",
            confirmButtonText: "ตกลง",
            customClass: {
              popup: "format-pre",
            },
          }).then(() => {
            this.$store.commit("BacktoEditing");
          });
        } else {
          this.Swap();
        }
      });
    },
    Swap() {
      if (this.surveyStatus) {
        Swal.fire({
          title: `แบบสอบถามนี้ถูกเปิดการใช้งานแล้ว`,
          text: "การแก้ไขคำถามจะทำให้ความน่าเชื่อถือลดลงและผู้ตอบแบบสอบถามจะได้รับคำถามที่ไม่เท่ากัน",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            this.showMenu = true;
          }
        });
      } else {
        this.showMenu = true;
      }
    },
    moveto(item, move) {
      // if (
      //   this.Editing &&
      //   (this.$store.state.editingPreData.questionID === item.questionID ||
      //     this.$store.state.editingPreData.questionID === move.questionID)
      // ) {
      //   Swal.fire({
      //     text:
      //       "คุณมีการแก้ไขค้างไว้ คุณแน่ใจหรือไม่ว่าต้องการย้ายโดยที่ยังไม่กดบันทึก",
      //     icon: "warning",
      //     focusConfirm: false,
      //     focusCancel: false,
      //     focusDeny: false,
      //     showConfirmButton: true,
      //     showDenyButton: true,
      //     showCancelButton: true,
      //     confirmButtonColor: "#F06FAF",
      //     denyButtonColor: "#3085d6",
      //     cancelButtonColor: "#d33",
      //     confirmButtonText: "บันทึก",
      //     denyButtonText: "ไม่บันทึก",
      //     cancelButtonText: "ยกเลิก",
      //   }).then((result) => {
      //     if (result.isConfirmed) {
      //       this.$store.state.editingConfirm.edit = true;
      //       let vm = this;
      //       const edited = setInterval(() => {
      //         if (!vm.Editing) {
      //           vm.moved(item, move, "save");
      //           clearInterval(edited);
      //         }
      //       }, 0);
      //     } else if (result.isDenied) {
      //       this.moved(item, move, "unsave");
      //     }
      //   });
      // } else {
      //   this.moved(item, move, "noting");
      // }
      if (this.Editing) {
        Swal.fire({
          title: "",
          text: `คุณมีการแก้ไข "${this.$store.state.editingPreData.questionLabel}" ค้างไว้ กรุณาดำเนินการให้เรียบร้อย`,
          icon: "warning",
          confirmButtonText: "ตกลง",
          customClass: {
            popup: "format-pre",
          },
        }).then(() => {
          this.$store.commit("BacktoEditing");
        });
      } else {
        this.moved(item, move, "noting");
      }
    },
    moved(item, move) {
      let moveindex = this.questionlist.findIndex(
        (e) => e.questionID === move.questionID
      );
      this.$store
        .dispatch("QuestionIndexMoving", {
          questionID: item.questionID,
          indexing: moveindex,
        })
        .then((response) => {
          this.$store.commit("UpdateQuestion", response.data);
          // if (this.$store.state.editingPreData) {
          //   let openlabel = this.$store.state.allquestion.find(
          //     (id) =>
          //       id.questionID === this.$store.state.editingPreData.questionID
          //   );
          //   if (openlabel) {
          //     if (state === "noting") {
          //       openlabel.editable = this.Editing;
          //     } else {
          //       openlabel.editable = false;
          //       if (state === "save") {
          //         this.$store.commit("UpdateQuestionPreEditing", null);
          //       }
          //       this.$store.commit("ToggleEditing");
          //     }
          //   }
          // }
        })
        .catch((err) => {
          let text = "ไม่สามารถย้ายได้";
          console.log(err);
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              window.location.reload();
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            if (err.data.message === "Nothing happened") {
              text = "ไม่สามารถย้ายเข้าตัวเองได้";
            }
            Swal.fire({
              icon: "error",
              text: text,
              title: "",
            }).then(() => {
              this.$store.commit("ToggleLoading");
              this.$store.dispatch("getQuestionLabel", this.$route.params);
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
